package music.jammers.client.shared.event.track.domain.usecase

import music.jammers.client.shared.event.track.domain.repository.EventTrackRepository
import music.jammers.shared.event.domain.model.EventMember

class SignInTrackUseCase(
    private val eventTrackRepository: EventTrackRepository,
) {

    suspend operator fun invoke(eventMember: EventMember): EventMember =
        eventTrackRepository.acceptMember(eventMember.id)
}